import { visitasListScope } from './visitasOfflineList.js';

export function activosCatalogScope(user) {
    return user?.tipo_acceso==='empresa' && ['access.visitas','visitas.view_any','visitas.editar_formularios','visitas.descargar_catalogo_activos'].every(p=>user?.permissions?.includes(p)) ? visitasListScope(user) : null;
}
export function activosCatalogPrefix(user,scope=activosCatalogScope(user)) {
    if(!scope)return null;
    let hash=2166136261;for(const c of scope)hash=Math.imul(hash^c.charCodeAt(0),16777619);
    return `catalog:${Number(user.empresa_id)}:${Number(user.id)}:${(hash>>>0).toString(16)}`;
}
